"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundButton = void 0;
var react_1 = __importStar(require("react"));
var utils_1 = require("../lib/utils");
var styles_1 = require("@material-ui/core/styles");
var VolumeUp_1 = __importDefault(require("@material-ui/icons/VolumeUp"));
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var hooks_1 = require("../hooks");
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        audio: {
            display: 'none',
        },
    });
});
var getInitialState = function (props) { return ({
    url: '',
    key: Math.random(),
    playing: false,
    time: {
        currentTime: 0,
        duration: 0,
    },
    playerTimeout: null,
    src: props.src,
}); };
var SoundButton = function (props) {
    var _a, _b, _c;
    var player = react_1.useRef(null);
    var _d = hooks_1.useMedia(getInitialState(props)), state = _d.state, pause = _d.pause, load = _d.load;
    var classes = useStyles();
    var _e = props.onEnded, onEnded = _e === void 0 ? function () { } : _e;
    react_1.useEffect(function () {
        player.current.onended = function () {
            pause(player.current);
            onEnded();
        };
    }, [pause, onEnded]);
    var onPlay = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var audioUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!player.current.src) return [3 /*break*/, 2];
                    return [4 /*yield*/, utils_1.getUrl(props.src)];
                case 1:
                    audioUrl = _a.sent();
                    load(player.current, audioUrl);
                    _a.label = 2;
                case 2:
                    player.current.pause();
                    player.current.currentTime = 0;
                    player.current.play();
                    return [2 /*return*/];
            }
        });
    }); }, [props.src, load]);
    return (react_1.default.createElement(IconButton_1.default, __assign({ onClick: onPlay, color: props.color }, (_a = props.PlayProps) === null || _a === void 0 ? void 0 : _a.attributes),
        react_1.default.createElement("audio", { key: state.key, ref: player, className: classes.audio }, state.url && react_1.default.createElement("source", { type: utils_1.getMimeType(state.url), src: state.url })),
        ((_c = (_b = props.PlayProps) === null || _b === void 0 ? void 0 : _b.icons) === null || _c === void 0 ? void 0 : _c[0]) || react_1.default.createElement(VolumeUp_1.default, { fontSize: "large" })));
};
exports.SoundButton = SoundButton;
//# sourceMappingURL=SoundButton.js.map